// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".picture-comp[data-v-0455c87e]{width:100%;max-height:none}.picture-comp__img[data-v-0455c87e]{display:inline-block;width:100%;height:100%;object-fit:cover}", ""]);
// Exports
module.exports = exports;
